export default "__VITE_ASSET__CuiEuyAY__"